import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListProductionObjectResource: IResourceConfig = {
    title: "Об'єкти виробництва",
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        region: {
            label: 'Регіон',
            isRequired: true,
            type: 'select',
            resource: 'Setting.ListRegion',
            /** У фільтрі — кілька регіонів (region in […]) */
            isFilterMultiple: true,
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        responsibles: {
            label: 'Відповідальні',
            type: 'select',
            isMultiple: true,
            resource: 'Setting.User',
            /** У фільтрі — об'єкти, де відповідальний хоча б один із обраних */
            isFilterMultiple: true,
            inputProps: {
                filter: { status: 'active' },
                responseLabel: (item: any) =>
                    item?.fullName || `${item?.lastName || ''} ${item?.firstName || ''}`.trim() || '—',
            },
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: ['id', 'title', 'code', 'isActive', 'region', 'responsibles', 'externalCode'],
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/production-objects',
    pageUrl: '/settings/production-objects',
    primaryFieldCode: 'code',
    /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
    detailConfig: { onButtons: dictionaryDetailButtons },
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
